export default {
  WEBSITE_UI_NAME: '易趣'
}
